var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatesTableZeroState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration-Empty-State-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 65"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 64"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 63"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 62"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 31.5492,
    cy: 41.5157,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 35",
    cx: 180.476,
    cy: 59.1768,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 36",
    cx: 201.956,
    cy: 68.2463,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 37",
    cx: 199.569,
    cy: 98.3181,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.8076,
    cy: 100.347,
    rx: 68.2583,
    ry: 67.6616,
    fill: "#787E8C",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.066 100.347C167.066 137.155 136.962 167.009 99.8076 167.009C62.6536 167.009 32.5493 137.155 32.5493 100.347C32.5493 63.539 62.6536 33.6853 99.8076 33.6853C136.962 33.6853 167.066 63.539 167.066 100.347Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 13",
    cx: 9.11465,
    cy: 69.6783,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 16",
    cx: 60.6664,
    cy: 181.851,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 92.1701,
    cy: 192.83,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 149.45,
    cy: 179.942,
    r: 1,
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 1.81865
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 20",
    opacity: 0.3,
    cx: 123.197,
    cy: 177.078,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 21",
    opacity: 0.15,
    cx: 127.97,
    cy: 190.92,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 22",
    opacity: 0.3,
    cx: 109.354,
    cy: 196.648,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 23",
    opacity: 0.3,
    cx: 173.794,
    cy: 166.815,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 38",
    opacity: 0.3,
    cx: 189.068,
    cy: 138.414,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 39",
    opacity: 0.15,
    cx: 179.76,
    cy: 123.616,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 40",
    opacity: 0.3,
    cx: 183.579,
    cy: 93.5447,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 41",
    opacity: 0.3,
    cx: 191.455,
    cy: 77.3156,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 42",
    opacity: 0.15,
    cx: 185.966,
    cy: 40.7997,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 24",
    opacity: 0.15,
    cx: 73.3156,
    cy: 199.035,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 25",
    opacity: 0.3,
    cx: 39.1865,
    cy: 194.262,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 26",
    opacity: 0.15,
    cx: 43.9599,
    cy: 185.908,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 27",
    opacity: 0.15,
    cx: 12.9333,
    cy: 147.722,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 28",
    opacity: 0.3,
    cx: 19.8545,
    cy: 132.925,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 29",
    opacity: 0.15,
    cx: 2.19333,
    cy: 94.4994,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 30",
    opacity: 0.3,
    cx: 21.0481,
    cy: 64.6664,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 31",
    opacity: 0.15,
    cx: 24.8667,
    cy: 22.4226,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 32",
    opacity: 0.3,
    cx: 61.3823,
    cy: 6.19333,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 33",
    opacity: 0.15,
    cx: 107.922,
    cy: 24.8093,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 34",
    cx: 133.937,
    cy: 18.8425,
    r: 1.19333,
    fill: "#787E8C",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 19",
    d: "M169.975 150.347C168.921 150.347 168.066 149.493 168.066 148.438C168.066 147.384 168.921 146.529 169.975 146.529",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 14",
    d: "M6.01196 117.65C7.06645 117.65 7.92129 116.795 7.92129 115.741C7.92129 114.686 7.06645 113.831 6.01196 113.831",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 43",
    d: "M74.0315 22.4227C75.086 22.4227 75.9408 21.5679 75.9408 20.5134C75.9408 19.4589 75.086 18.6041 74.0315 18.6041",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 44",
    d: "M120.333 15.7399C119.278 15.7399 118.423 16.5947 118.423 17.6492C118.423 18.7037 119.278 19.5585 120.333 19.5585",
    stroke: "#787E8C",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 13",
    d: "M9.83057 166.934H15.7972M25.8211 155.836V157.388M37.5157 166.934H39.0671M25.8211 176.481V178.271M25.8211 180.658V186.982M21.4058 166.934C24.3892 166.934 25.9405 162.638 25.9405 162.638C25.9405 162.638 26.4178 166.934 30.2365 166.934C28.5181 166.934 26.0598 168.486 25.8211 171.588C25.8211 171.588 25.5432 169.048 24.6278 168.128C23.8635 167.359 21.4058 166.934 21.4058 166.934Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    d: "M178.209 30.0597L172.242 30.0597M162.099 45.8116L162.218 39.6063M150.524 30.0597L148.972 30.0597M162.099 20.7518L162.099 8.57985M166.634 30.0597C163.65 30.0597 162.099 34.3557 162.099 34.3557C162.099 34.3557 161.622 30.0597 157.803 30.0597C159.521 30.0597 161.98 28.5084 162.218 25.4057C162.218 25.4057 162.496 27.9459 163.412 28.8664C164.176 29.635 166.634 30.0597 166.634 30.0597Z",
    stroke: "#787E8C",
    strokeOpacity: 0.8,
    strokeWidth: 2
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group 78"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 56",
    d: "M56.5 147.5L61 145.5L67 159.5L61 162L58.5 160.5L54.5 151V149L56.5 147.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 55",
    d: "M101.5 51L41 50.5C35.8 50.9 33.8333 55 33.5 57L33 110.5V134L35.5 137L38.5 139.5H58.5L59 136L60.5 134L64 132L76.5 126.5L96.5 117.5L102.5 113.5L108.5 107.5V59.5C108.5 53.1 103.833 51.1667 101.5 51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 54",
    d: "M85.1553 167.921L82.8076 163.616L98.0675 157.356L105.893 168.703C107.067 170.79 109.806 174.67 104.719 178.485C100.963 181.302 97.4154 178.616 96.1111 176.92L91.4158 169.877L85.1553 167.921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.4548 133.081L81.2362 124.316L97.67 116.647C100.539 115.212 107.687 110.23 113.321 101.778C117.704 94.8916 119.582 92.1265 119.973 91.6048C121.669 89.7789 126.547 87.2225 132.494 91.6048C134.685 96.6132 147.493 123.69 153.623 136.602C154.927 139.471 155.501 145.836 147.363 148.34C142.354 147.714 132.755 146.775 128.581 146.384C125.973 146.254 119.66 146.462 115.278 148.34C112.828 149.39 105.049 153.015 96.8874 156.851C90.4465 159.878 83.767 163.037 79.2799 165.166C76.9322 166.6 71.6108 168.217 69.1066 163.209C68.6237 162.243 68.0361 161.039 67.3853 159.688C64.6608 154.03 60.8283 145.795 58.9333 141.689C57.8899 139.854 57.1334 135.564 62.4548 133.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2362 124.316L96.8874 156.851M60.4984 145.601L56.108 147.797C54.638 148.532 54.033 150.312 54.7511 151.791L58.8553 160.241C59.5558 161.683 61.2663 162.319 62.7391 161.686L67.3853 159.688M67.3853 159.688C68.0361 161.039 68.6237 162.243 69.1066 163.209C71.6108 168.217 76.9322 166.6 79.2799 165.166C89.4532 160.34 110.895 150.219 115.278 148.34C119.66 146.462 125.973 146.254 128.581 146.384C132.755 146.775 142.354 147.714 147.363 148.34C155.501 145.836 154.927 139.471 153.623 136.602C147.493 123.69 134.685 96.6132 132.494 91.6048C126.547 87.2225 121.669 89.7789 119.973 91.6048C119.582 92.1265 117.704 94.8916 113.321 101.778C107.687 110.23 100.539 115.212 97.67 116.647L62.4548 133.081C57.1334 135.564 57.8899 139.854 58.9333 141.689C60.8283 145.795 64.6608 154.03 67.3853 159.688Z",
    stroke: "#787E8C",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 49",
    d: "M147.895 124.863C153.792 122.169 156.389 115.206 153.696 109.309C151.002 103.412 144.039 100.814 138.142 103.508",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 52",
    d: "M82 163.26L84.3477 167.565L90.6082 169.521L95.3035 176.564C96.6078 178.26 100.155 180.946 103.912 178.129C108.998 174.314 106.259 170.434 105.086 168.347L97.2599 157",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M51.8902 139.341H40.5C36.634 139.341 33.5 136.207 33.5 132.341V57.9117C33.5 54.0457 36.634 50.9117 40.5 50.9117H101.626C105.492 50.9117 108.626 54.0457 108.626 57.9117V97.8653",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 76"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 118",
    x: 116.799,
    y: 37,
    width: 40,
    height: 40,
    rx: 6,
    fill: "#F2F3F4",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 54_2",
    d: "M116.754 71.3183L125.826 57.847C126.552 56.7693 128.097 56.6589 128.968 57.6223L131.626 60.5596C132.485 61.5087 134.001 61.4182 134.741 60.3738L142.561 49.3346C143.336 48.24 144.948 48.2039 145.771 49.2627L157.481 64.3183",
    stroke: "#787E8C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 127.572,
    cy: 47.1364,
    r: 3.13636,
    stroke: "#787E8C",
    strokeWidth: 2
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector 44",
    d: "M76.5 69H95.5",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 48",
    d: "M76.5 78H95.5",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 45",
    d: "M44.7021 93.1572H60.5224",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M44.7021 122H60.5224",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 46",
    d: "M62.6797 93.1572H99.3538",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 47",
    d: "M44.7021 102.506L99.3538 102.506",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 49",
    d: "M44.5 112H81.5",
    stroke: "#194590",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo Fijo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.2926 86.5852C53.8746 86.5852 50.6627 85.2534 48.2454 82.8398C45.8282 80.4262 44.5 77.2106 44.5 73.7926C44.5 70.3746 45.8319 67.1627 48.2454 64.7454C50.659 62.3282 53.8746 61 57.2926 61C60.7106 61 63.9226 62.3319 66.3398 64.7454C68.757 67.159 70.0852 70.3746 70.0852 73.7926C70.0852 77.2106 68.7534 80.4226 66.3398 82.8398C63.9262 85.257 60.7106 86.5852 57.2926 86.5852ZM57.2926 61.1472C53.9151 61.1472 50.7399 62.4643 48.3521 64.8521C45.9643 67.2399 44.6472 70.4151 44.6472 73.7926C44.6472 77.1701 45.9643 80.3453 48.3521 82.7331C50.7399 85.1209 53.9151 86.4381 57.2926 86.4381C60.6701 86.4381 63.8453 85.1209 66.2331 82.7331C68.6209 80.3453 69.9381 77.1701 69.9381 73.7926C69.9381 70.4151 68.6209 67.2399 66.2331 64.8521C63.8453 62.4643 60.6701 61.1472 57.2926 61.1472Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.2926 83.2188C54.776 83.2188 52.4103 82.2401 50.6295 80.4594C48.8488 78.6787 47.8701 76.3129 47.8701 73.7964C47.8701 71.2798 48.8488 68.914 50.6295 67.1333C52.4103 65.3526 54.776 64.3739 57.2926 64.3739C59.8092 64.3739 62.1749 65.3526 63.9556 67.1333C65.7364 68.914 66.715 71.2798 66.715 73.7964C66.715 76.3129 65.7364 78.6787 63.9556 80.4594C62.1749 82.2401 59.8092 83.2188 57.2926 83.2188ZM57.2926 64.5137C54.8128 64.5137 52.4838 65.4777 50.7325 67.2326C48.9812 68.984 48.0136 71.3129 48.0136 73.7927C48.0136 76.2725 48.9776 78.6014 50.7325 80.3527C52.4838 82.104 54.8128 83.0716 57.2926 83.0716C59.7724 83.0716 62.1013 82.1077 63.8526 80.3527C65.6039 78.6014 66.5715 76.2725 66.5715 73.7927C66.5715 71.3129 65.6076 68.984 63.8526 67.2326C62.1013 65.4813 59.7724 64.5137 57.2926 64.5137Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M57.2924 77.4461C55.2762 77.4461 53.6389 75.8089 53.6389 73.7927C53.6389 71.7765 55.2762 70.1392 57.2924 70.1392C59.3086 70.1392 60.9458 71.7765 60.9458 73.7927C60.9458 75.8089 59.3086 77.4461 57.2924 77.4461ZM57.2924 70.2864C55.3608 70.2864 53.7861 71.8611 53.7861 73.7927C53.7861 75.7243 55.3608 77.299 57.2924 77.299C59.224 77.299 60.7987 75.7243 60.7987 73.7927C60.7987 71.8611 59.224 70.2864 57.2924 70.2864Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.4,
    d: "M62.9439 76.0848C66.2317 76.0848 68.8969 73.4196 68.8969 70.1319C68.8969 66.8441 66.2317 64.1789 62.9439 64.1789C59.6562 64.1789 56.991 66.8441 56.991 70.1319C56.991 73.4196 59.6562 76.0848 62.9439 76.0848Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M57.2926 86.5852C53.8746 86.5852 50.6627 85.2534 48.2454 82.8398C45.8282 80.4262 44.5 77.2106 44.5 73.7926C44.5 70.3746 45.8319 67.1627 48.2454 64.7454C50.659 62.3282 53.8746 61 57.2926 61C60.7106 61 63.9226 62.3319 66.3398 64.7454C68.757 67.159 70.0852 70.3746 70.0852 73.7926C70.0852 77.2106 68.7534 80.4226 66.3398 82.8398C63.9262 85.257 60.7106 86.5852 57.2926 86.5852ZM57.2926 61.1472C53.9151 61.1472 50.7399 62.4643 48.3521 64.8521C45.9643 67.2399 44.6472 70.4151 44.6472 73.7926C44.6472 77.1701 45.9643 80.3453 48.3521 82.7331C50.7399 85.1209 53.9151 86.4381 57.2926 86.4381C60.6701 86.4381 63.8453 85.1209 66.2331 82.7331C68.6209 80.3453 69.9381 77.1701 69.9381 73.7926C69.9381 70.4151 68.6209 67.2399 66.2331 64.8521C63.8453 62.4643 60.6701 61.1472 57.2926 61.1472Z",
    fill: "#194590",
    stroke: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.4,
    d: "M46.8289 74.5358C46.0636 74.5358 45.3241 74.6388 44.6177 74.8302C44.6765 75.5403 44.7906 76.2319 44.9598 76.9052C45.5485 76.7213 46.1777 76.6219 46.8289 76.6219C50.2947 76.6219 53.1056 79.4329 53.1056 82.8987C53.1056 83.8553 52.8922 84.764 52.5059 85.5771C53.1498 85.8384 53.8231 86.0518 54.5148 86.2063C54.9526 85.1908 55.1954 84.076 55.1954 82.9023C55.1917 78.2813 51.4463 74.5358 46.8289 74.5358Z",
    fill: "#194590"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M66.612 65.1355C65.7253 64.1826 64.6988 63.3658 63.5582 62.722C64.2573 63.4357 64.6914 64.4107 64.6914 65.4887C64.6914 67.6705 62.9254 69.4365 60.7436 69.4365C58.5618 69.4365 56.7958 67.6705 56.7958 65.4887C56.7958 63.3143 58.5508 61.552 60.7215 61.5409C59.6325 61.2356 58.4809 61.0737 57.2962 61.0737C57.149 61.0737 57.0019 61.0773 56.8547 61.081C55.6369 62.159 54.8679 63.7337 54.8679 65.4887C54.8679 68.7375 57.4986 71.3681 60.7473 71.3681C63.996 71.3681 66.6267 68.7375 66.6267 65.4887C66.623 65.371 66.6156 65.2533 66.612 65.1355Z",
    fill: "#194590"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatesTableZeroState);
export default __webpack_public_path__ + "static/media/updates_table_zero_state.03794e20af1d1d5bbf7ace2fdd20b82f.svg";
export { ForwardRef as ReactComponent };